export class ValidationUtils {
    static isStringEmptyOrNull(testString: string): boolean {
        return testString === undefined || testString === null || testString === '';
    }
}
